import { useMutation } from '@tanstack/react-query';
import { orpc } from '../../../rpc/client';

/**
 * Hook to create a new memory bank note
 */
export function useCreateMemoryBankNote() {
  return useMutation(orpc.memoryBank.create.mutationOptions());
}

/**
 * Hook to update an existing memory bank note
 */
export function useUpdateMemoryBankNote() {
  return useMutation(orpc.memoryBank.update.mutationOptions());
}

/**
 * Hook to delete (archive) a memory bank note
 */
export function useDeleteMemoryBankNote() {
  return useMutation(orpc.memoryBank.delete.mutationOptions());
}
